import pkg from '../../package.json';

export const env = {
  version: pkg.version,
};
